import axios from "axios";
import { authHeader } from "./authHeader";

const API_URL = process.env.REACT_APP_API_URL;


const getLeads = (params) => {
    return axios.get(API_URL + '/api/leads', {
        params: params,
        headers: authHeader()
    });
};

const addLead = async (formData) => {
    const response = await axios.post(API_URL + "/api/leads", formData, {
        headers: authHeader()
    });
    console.log('Lead added:', response.data);
    return response.data;
};


const updateLead = async (l_id,formData) => {
    const response = await axios.put(API_URL + `/api/leads/update/${l_id}`, formData, {
        headers: authHeader()
    });
    return response.data;
};

const deleteLead = async (l_id) => {
    const response = await axios.delete(API_URL + `/api/leads/${l_id}`, {
        headers: authHeader()
    });
    return response.data;
};

const getLeadById = async (l_id) => {
    const response = await axios.get(API_URL + `/api/leads/${l_id}`, {
        headers: authHeader()
    });
    return response.data;
};

// Export Lead 

// Lead as CSV
const exportLeadAsCsv = async (params) => {
    return axios.get(API_URL + '/api/leads/export/csv', {
        params: params,
        headers: authHeader()
    });
}

// Lead as Excel
const exportLeadAsExcel = async (params) => {
    return axios.get(API_URL + '/api/leads/export/excel', {
        params: params,
        headers: authHeader()
    });
}

// Import Lead

const importLeads = async (formData) => {
    const response = await axios.post(API_URL + "/api/leads/import/upload-leads", formData, {
        headers: authHeader()
    });
    console.log('Lead added:', response.data);
    return response.data;
};

const LEADAPI = {
    getLeads,
    addLead,
    updateLead,
    deleteLead,
    getLeadById,
    exportLeadAsCsv,
    exportLeadAsExcel,
    importLeads
};

export default LEADAPI;

